export const FORM_FIELDS = {
  FULL_NAME: 'fullName',
  LAST_NAME: 'lastName',
  MIDDLE_NAME: 'middleName',
  FIRST_NAME: 'firstName',
  PHONENUMBER: 'primaryPhone',
  GENDER: 'genderCode',
  BIRTHDAY: 'birthday',
  MONTHLY_INCOME: 'income',
  HOME_ID: 'homeId',
  ID_CARD: 'idNumber',
  DOCUMENT: 'document',
};

export const initialValue = {
  [FORM_FIELDS.LAST_NAME]: '',
  [FORM_FIELDS.FIRST_NAME]: '',
  [FORM_FIELDS.MIDDLE_NAME]: '',
  [FORM_FIELDS.PHONENUMBER]: '',
  [FORM_FIELDS.MONTHLY_INCOME]: '',
  [FORM_FIELDS.ID_CARD]: '',
};

export const GENDER_MALE = 'MALE';
export const GENDER_FEMALE = 'FEMALE';
export const SA_CODE_STORE_MAX_AGE = 60 * 60;
export const SA_CODE_KEY_COOKIE = 'saCode';
